import { useState, useEffect, useCallback } from "react";
import { buildMedalleroEndpoint, DEFAULT_EVENT_ID, DEFAULT_SPORT_ID } from "./medallero.utils";

const useMedallero = (eventId = DEFAULT_EVENT_ID, sportId = DEFAULT_SPORT_ID) => {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const url = buildMedalleroEndpoint(eventId, sportId);
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Error ${res.status}: ${res.statusText}`);
      const json = await res.json();
      setData(json?.general ?? []);
    } catch (err) {
      setError(err.message || "Error al cargar el medallero");
    } finally {
      setLoading(false);
    }
  }, [eventId, sportId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
};

export default useMedallero;